import { createRoot } from 'react-dom/client'

import { LoaderWrapper } from 'hpscm/components/layout/LoaderWrapper'
import { WidgetSelector } from 'hpscm/components/widgets/WidgetSelector'
import { lazyWidgets } from 'hpscm/constants/lazyWidgets'
import { registryEmailValidator } from 'hpscm/helpers/registryEmailValidator'
import { CustomRoutes } from 'hpscm/routes/CustomRoutes'
import { hpscmProjectReducer, hpscmRemoteReducers } from 'hpscm/store'
import { App } from 'src/core/components/App'

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)

root.render(
  <App
    appStore={{
      storeReducer: hpscmProjectReducer,
      remoteReducers: hpscmRemoteReducers,
    }}
    CustomRoutes={CustomRoutes}
    AppWidgets={WidgetSelector}
    AppLazyWidgets={lazyWidgets}
    LoaderWrapper={LoaderWrapper}
    headerSettings={{
      editModeAccessRoles: ['KB Admin', 'Publisher'],
    }}
    userSettings={{
      allowedEmailsValidator: registryEmailValidator,
    }}
  />
)
